<template>
  <main>
    <LoadingFrame ref="gfLoadingFrame" />
    <NotiCenter v-if="shopInfo" />
    <div class="gp-wrapper" :class="{ bg: $route.name === 'AccountSettings', 'white-background': $route.name === 'PricingOnboarding' }" ref="mainBody" id="mainBody" v-if="shopInfo">
      <NotiBar :hide="loadingDashboard" />
      <Modal v-if="notiAction.isViewingNoti" :preventBackdrop="false" @cancel="closeNoti" @container="closeNoti" :cClass="notiModalClass" closeClass="extend-trial-close" :noBreakLine="false" :hideExit="true" mClass="p-0 border-radius" iClass="typo-icon-25 p12">
        <template #default>
          <NotificationPopup :notification="notiAction.noti" @close="closeNoti" />
        </template>
      </Modal>

      <Modal @cancel="closeSwitchAgency" :hideExit="true" v-if="isOpenAgencySwitchModal" :cClass="switchAgencyModalClass" aClass="ml-4 mr-4 mt-3 mb-0" closeClass="extend-trial-close" fClass="p-4 pt-2 " :noBreakLine="false" mClass="p-4 pt-0" iClass="typo-icon-25 p12">
        <template #header>
          <div class="">
            <p class="typo-heading20 typo-medium text-light-high">{{ $t("agency.switchStore") }}</p>
          </div>
        </template>
        <template #actions>
          <GpInputSearch ref="input" :class="{ focusing: true }" :clear="true" v-model="queryShopName" @input="searchShop" :placeholder="$t('generals.searchShops')" />
          <div class="d-flex justify-content-between align-items-center mt-3">
            <p class="type-button14 typo-medium text-light-high">{{ $t("agency.storeSelect") }}</p>
            <FilterPage @onClickFilter="onClickFilter" lclass="dropdown" :type="'shops'" />
          </div>
        </template>
        <template #default>
          <div>
            <div class="gem-page-list">
              <template v-if="sortedShopList && sortedShopList.length">
                <!-- <Pagination :pagina.sync="pagination" :total.sync="totalPagesPagination" @page="toPage" v-if="totalPages > pagination.limit" /> -->
              </template>
            </div>
          </div>
        </template>
        <template #footer>
          <div class="d-flex flex-row-reverse">
            <button @click="closeSwitchAgency" class="btn btn-outline">{{ $t("generals.cancel") }}</button>
          </div>
        </template>
      </Modal>
      <Modal @cancel="closeFaqs" :hideExit="false" v-if="isFaqsModalActive" classs="modal-blur faqs-modal" mClass="m-auto faqs height-unlimit" closeClass="faqs-close">
        <FaqsModal />
      </Modal>

      <div
        ref="gpMainBody"
        :class="{
          'container gp-main-body px-1 px-xs-2 px-sm-4 px-md-5 px-xl-6 px-lg-2 px-mlg-2': !layoutIframe,
          'layout-iframe': layoutIframe
        }"
      >
        <div class="gp-main-body-wrapper">
          <div class="col-lg-12" :class="{ 'sticky-head': $route.name === 'AccountSettings' }" v-if="headerVisible && notDashboard && $route.name != 'InstantPages'">
            <header class="row pb-5">
              <div class="col-12 col-sm-8 col-lg-7 col-xl-8">
                <div class="row">
                  <div v-if="shopInfo.hasAgency == false" class="shop-info">
                    <h2 class="flex-v-center heading-h2-24-semi text-light-high shop-name">{{ headerTitleText }}</h2>
                    <p class="paragraph-14-16-regular text-light-low mt-sm-1" v-if="headerDescription">{{ headerDescriptionText }}</p>
                    <a class="domain flex-v-center typo-body3 text-grey2" :href="shopDomainURL" target="_blank" rel="noopener noreferrer" v-if="headerDomain">{{ headerDomain }}</a>
                    <p class="typo-paragrap14 typo-regular text-lightmode" v-if="headerSubtitle">{{ headerSubtitleText }}</p>
                  </div>
                  <div v-else class="shop-info">
                    <template v-if="$route.name == 'Dashboard'">
                      <router-link replace :to="{ name: 'AgencyDashboard' }" v-if="agencyLogged && agencyInfo.id == shopInfo.agency.id">
                        <!-- <img :src="`${publicPath}${shopInfo.agency.logo}`" alt=""> -->
                        <div class="shop-logo">
                          <img :src="shopInfo.agency.logo" alt v-if="shopInfo && shopInfo.agency && shopInfo.agency.logo" />
                          <img :src="publicPath + require('@/core/assets/agency-logo.svg')" alt v-else />
                        </div>
                      </router-link>
                      <div @click="openModalLogin" v-else>
                        <div class="shop-logo">
                          <img :src="shopInfo.agency.logo" alt v-if="shopInfo && shopInfo.agency && shopInfo.agency.logo" />
                          <img :src="publicPath + require('@/core/assets/agency-logo.svg')" alt v-else />
                        </div>
                      </div>
                    </template>

                    <h2 class="flex-v-center typo-heading24 typo-semibold" v-else>{{ headerTitleText }}</h2>
                    <p class="typo-button14 typo-medium text-light-low mt-sm-1" v-if="headerDescription">{{ headerDescriptionText }}</p>
                    <template v-if="$route.name == 'Dashboard'">
                      <StoreSelect :shop="shopInfo" :stores="shopList.list" v-if="agencyLogged && agencyInfo.id == shopInfo.agency.id"></StoreSelect>
                      <template v-else>
                        <p @click="openModalLogin" class="login-btn" v-if="agencyFetched">{{ $t("agency.login") }}</p>
                      </template>
                      <Modal classs="modal-blur backdrop-f2f3f4" mClass="m-auto" @cancel="closeModalLogin" v-if="modalAgencyLogin" @container="closeModalLogin">
                        <form @submit.prevent="checkLogin" class="agency-login-form pt-3 px-4 pb-4">
                          <h3 class="typo-h4 mb-2 text-center">{{ $t("agency.login") }}</h3>
                          <p class="typo-body2 mb-4 px-6 text-center">{{ $t("agency.loginDesc") }}</p>
                          <div class="form-group">
                            <label class="typo-body2 label text-black1" v-focus>{{ $t("generals.email") }}</label>
                            <input class="input-field input-field-border typo-body2" :class="{ 'is-error': formControl.error.other || formControl.error.email }" autocomplete="agency-email" type="text" v-model="formControl.email" v-focus />
                          </div>
                          <p class="lh-16 text-red typo-subtext mb-n2" v-if="formControl.error.email">{{ formControl.error.email }}</p>
                          <div class="form-group mt-3">
                            <label class="typo-body2 label text-black1">{{ $t("generals.password") }}</label>
                            <div class="form-password form-group">
                              <input class="input-field input-field-border typo-body2" :class="{ 'is-error': formControl.error.other || formControl.error.password }" autocomplete="agency-password" :type="formControl.showPassword ? 'text' : 'password'" v-model="formControl.password" />
                              <div class="password-action" @click="toggleShowPassword">
                                <i class="icon icon-view" v-if="!formControl.showPassword"></i>
                                <i class="icon icon-view-off" v-else></i>
                              </div>
                            </div>
                            <p class="lh-16 text-red typo-subtext mb-n2" v-if="formControl.error.password">{{ formControl.error.password }}</p>
                          </div>
                          <p class="lh-16 text-red typo-subtext mt-2 mb-n4" v-if="formControl.error.other">{{ formControl.error.other }}</p>
                          <ProcessButton class="btn-block mt-5" :status.sync="accounStatus" type="submit" default="btn-primary">
                            <template #loading>{{ $t("agency.signin") }}</template>
                            <template #success>{{ $t("generals.success") }}</template>
                            <template #error>{{ $t("agency.signin") }}</template>
                            <template #default>{{ $t("agency.signin") }}</template>
                          </ProcessButton>
                          <p class="typo-subtext mt-1 mb-3">
                            <a href="/agency/password/new" target="_blank" rel="noopener noreferrer" class="text-grey2">{{ $t("agency.forgot") }}</a>
                          </p>
                        </form>
                      </Modal>
                    </template>
                  </div>
                </div>
              </div>

              <div class="col-12 col-sm-4 col-lg-5 col-xl-4 d-flex flex-column-reverse">
                <PortalTarget class="row" name="headerActions" multiple />
              </div>
            </header>

            <section class="row pb-2" v-if="breadcrums != undefined && breadcrums.length > 0">
              <div class="typo-h5 flex-v-center breadcrumb row">
                <template v-for="(item, index) in breadcrums">
                  <router-link replace class="rl" :to="{ name: item.to }" :key="`breadcrumb-link-${index}`" v-if="item.to != undefined">{{ item.name }}</router-link>

                  <router-link replace class="rl" :to="{ name: item.to }" :tag="item.to ? 'a' : 'span'" :key="`breadcrumb-link-${index}`" v-else>{{ item.name }}</router-link>
                  <i class="icon icon-arrow-right" v-if="item.to != undefined" :key="`breadcrumb-arrow-${index}`" />
                </template>
              </div>
            </section>
          </div>

          <router-view />
        </div>
      </div>

      <!-- Shareable Library -->
      <Modal :hideExit="true" v-if="modals.sharedLibrary.active" cClass="maxw-80p">
        <template #default>
          <article class="shareable-template-modal p-md-1" v-if="!modals.sharedLibrary.accepted">
            <div class="container share" v-if="modals.sharedLibrary.data">
              <div class="title d-flex align-items-center justify-content-center">
                <svg width="28" height="30" viewBox="0 0 28 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20.6607 29.1392C20.4607 29.1392 20.2607 29.1392 20.0607 29.1392C19.2607 28.9392 18.6607 28.5392 18.2607 27.9392L12.4607 20.1392H3.26074C1.66074 20.1392 0.260742 18.7392 0.260742 17.1392C0.260742 16.1392 0.860742 15.1392 1.66074 14.7392L23.2607 1.33919C23.8607 0.939194 24.6607 0.739194 25.4607 0.939194C26.2607 1.13919 26.8607 1.53919 27.2607 2.33919C27.6607 2.93919 27.8607 3.73919 27.6607 4.53919L23.4607 26.9392C23.2607 27.7392 22.8607 28.3392 22.2607 28.7392C21.8607 28.9392 21.2607 29.1392 20.6607 29.1392ZM24.8607 2.73919C24.6607 2.73919 24.4607 2.73919 24.4607 2.93919L2.86074 16.3392C2.46074 16.5392 2.26074 16.9392 2.26074 17.1392C2.26074 17.7392 2.66074 18.1392 3.26074 18.1392H13.0607C13.4607 18.1392 13.6607 18.3392 13.8607 18.5392L19.8607 26.7392C20.0607 26.9392 20.2607 27.1392 20.4607 27.1392C20.6607 27.1392 20.8607 27.1392 21.2607 26.9392C21.4607 26.7392 21.6607 26.5392 21.6607 26.3392L25.8607 3.93919C25.8607 3.73919 25.8607 3.53919 25.6607 3.33919C25.4607 3.13919 25.2607 2.93919 25.0607 2.93919C25.0607 2.73919 24.8607 2.73919 24.8607 2.73919Z" fill="#3C67FF"></path>
                  <path d="M12.0605 28.1391C10.4605 28.1391 9.06055 26.7391 9.06055 25.1391V19.1391C9.06055 18.5391 9.46055 18.1391 10.0605 18.1391H13.0605C13.4605 18.1391 13.6605 18.3391 13.8605 18.5391L17.6605 23.7391C17.8605 23.9391 17.8605 24.1391 17.8605 24.5391C17.8605 24.9391 17.6605 25.1391 17.4605 25.1391L13.6605 27.7391C13.2605 27.9391 12.6605 28.1391 12.0605 28.1391ZM11.0605 20.1391V25.1391C11.0605 25.9391 12.0605 26.3391 12.6605 25.9391L15.4605 23.9391L12.6605 20.1391H11.0605Z" fill="#3C67FF"></path>
                  <path d="M13.061 20.1394C12.861 20.1394 12.661 20.1394 12.461 19.9394C12.061 19.5394 11.861 18.9394 12.261 18.5394L25.1376 1.66256C25.5376 1.26256 26.1376 1.06256 26.5376 1.46256C26.9376 1.86256 27.1376 2.46256 26.7376 2.86256L13.861 19.7394C13.661 19.9394 13.261 20.1394 13.061 20.1394Z" fill="#3C67FF"></path>
                </svg>
                <h1 class="typo-heading32 typo-semi-150 text-mono3 ml-1">
                  Library Sharing
                </h1>
              </div>
              <div class="row share-body mt-5">
                <div class="col-md-6 d-flex align-items-center">
                  <img width="100%" height="auto" :src="publicPath + require('@/core/assets/share.png')" />
                </div>
                <div class="col-md-6">
                  <p class="typo-heading24 typo-semi text-light-high">
                    {{ modals.sharedLibrary.data.title }}
                  </p>
                  <p class="mt-half typo-paragraph12 typo-medium text-light-low">
                    Shared by <b>{{ modals.sharedLibrary.data.author }}</b>
                  </p>
                  <p class="typo-paragraph14 typo-regular-150 text-light-low mt-1">
                    {{ modals.sharedLibrary.data.description }}
                  </p>
                  <div class="templates mt-5" v-if="modals.sharedLibrary.data.templates && modals.sharedLibrary.data.templates.length">
                    <p class="typo-heading16 typo-medium-150">{{ modals.sharedLibrary.data.templates.length }} {{ $tc("generals.template", modals.sharedLibrary.data.templates.length | 1) }}:</p>

                    <div class="items mt-2">
                      <div class="item d-flex align-items-center mb-1" v-for="(item, index) in modals.sharedLibrary.data.templates" :key="index">
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M11.5714 0.289237C11.8259 0.467395 11.8878 0.818132 11.7097 1.07263L4.66841 11.1311C4.16697 11.8509 3.17656 12.0289 2.45643 11.5277C2.31644 11.4303 2.19305 11.311 2.09099 11.1743L0.300054 8.78671C0.113643 8.5382 0.163988 8.18562 0.412505 7.99921C0.661021 7.8128 1.0136 7.86314 1.20001 8.11166L2.9922 10.5009C3.02202 10.5409 3.0581 10.5758 3.09905 10.6043C3.3094 10.7507 3.59861 10.6988 3.74501 10.4885L3.7459 10.4872L10.788 0.427466C10.9662 0.172967 11.3169 0.11108 11.5714 0.289237Z" fill="#3C67FF"></path>
                        </svg>
                        <p class="typo-paragraph16 typo-regular-150 text-mono3 ml-1">
                          {{ item.name }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="blocks mt-2" v-if="modals.sharedLibrary.data.blocks && modals.sharedLibrary.data.blocks.length">
                    <p class="typo-heading16 typo-medium-150">{{ modals.sharedLibrary.data.blocks.length }} {{ $tc("generals.template", modals.sharedLibrary.data.blocks.length | 1) }}:</p>

                    <div class="items mt-2">
                      <div class="item d-flex align-items-center mb-1" v-for="(item, index) in modals.sharedLibrary.data.blocks" :key="index">
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M11.5714 0.289237C11.8259 0.467395 11.8878 0.818132 11.7097 1.07263L4.66841 11.1311C4.16697 11.8509 3.17656 12.0289 2.45643 11.5277C2.31644 11.4303 2.19305 11.311 2.09099 11.1743L0.300054 8.78671C0.113643 8.5382 0.163988 8.18562 0.412505 7.99921C0.661021 7.8128 1.0136 7.86314 1.20001 8.11166L2.9922 10.5009C3.02202 10.5409 3.0581 10.5758 3.09905 10.6043C3.3094 10.7507 3.59861 10.6988 3.74501 10.4885L3.7459 10.4872L10.788 0.427466C10.9662 0.172967 11.3169 0.11108 11.5714 0.289237Z" fill="#3C67FF"></path>
                        </svg>
                        <p class="typo-paragraph16 typo-regular-150 text-mono3 ml-1">
                          {{ item.name }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="row btn-group mt-5">
                    <div class="col-7 col-md-4">
                      <ProcessButton class="btn-block" :status.sync="import_status" @click="acceptLibrary">
                        <template #loading>{{ $t("generals.accept") }}</template>
                        <template #success>{{ $t("generals.accept") }}</template>
                        <template #error>{{ $t("template.shared.error") }}</template>
                        <template #default>{{ $t("generals.accept") }}</template>
                      </ProcessButton>
                    </div>
                    <div class="col-5 col-md-4">
                      <button class="btn btn-block btn-secondary text-lightmode" @click="discardLibrary">{{ $t("generals.discard") }}</button>
                    </div>
                  </div>
                  <div class="row mt-1">
                    <div class="col-12">
                      <p v-if="modals.sharedLibrary.error" class="typo-paragraph12 typo-italic text-danger mt-half">{{ modals.sharedLibrary.error }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="container mt-4">
                <div class="row">
                  <div class="">
                    <div class="typo-paragraph12 typo-regular-150 text-light-low text-center">
                      Disclamer: This content is provided by an individual who created with GemPages user account. GemPages makes no representation or warranty of any insecure content since it’s not investigated, monitored, or checked for accuracy, reliability or completeness by us.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </article>
          <article class="shareable-template-modal" v-else>
            <section class="maxh-adaptive" v-if="modals.sharedLibrary.data && (modals.sharedLibrary.status != 'error_while_import' || modals.sharedLibrary.status != 'too_many')">
              <h2 class="typo-h3 text-center" v-if="modals.sharedLibrary.status == 'own'">{{ $t("template.shared.ownThis", { kind: $t(`template.shared.${modals.sharedLibrary.data.kind || "template"}`) }) }}</h2>
              <h2 class="typo-h3 text-center" v-else-if="modals.sharedLibrary.status == 'imported'">
                {{
                  $t("template.shared.imported", {
                    kind: $t(`template.shared.${modals.sharedLibrary.data.kind || "template"}`)
                  })
                }}
              </h2>
              <h2 class="typo-h3 text-center" v-else>
                {{
                  $t("template.shared.saved", {
                    template: modals.sharedLibrary.data.title
                  })
                }}
              </h2>
              <p class="typo-body2 mt-2 description text-center">{{ $t("template.shared.findIn") }}</p>
              <img class="content-img maxw-500 mt-3" :src="publicPath + require('@/core/assets/my-library.jpg')" alt />
            </section>
            <section class="maxh-adaptive">
              <h2 class="typo-h3 text-center" v-if="modals.sharedLibrary.status == 'error_while_import'">{{ $t("template.shared.importError", { template: modals.sharedLibrary.data.title }) }}</h2>
              <h2 class="typo-h3 text-center" v-else-if="modals.sharedLibrary.status == 'too_many'">{{ $t("template.shared.tooMany", { template: modals.sharedLibrary.data.title }) }}</h2>
            </section>
            <div class="row btn-group justify-content-center mt-5">
              <div class="col-8 col-xs-7 col-sm-6 col-md-4 col-lg-3">
                <button class="btn btn-block btn-primary" @click="closeSharedLibrary">{{ $t("template.shared.ok") }}</button>
              </div>
            </div>
          </article>
        </template>
        <!-- <template #footer>
        <div class="btn-group justify-content-between mt-5">
          <button class="btn btn-block btn-danger ml-2">Accept</button>
        </div>
        </template>-->
      </Modal>
    </div>

    <!-- Welcome to new version -->
    <Modal :hideExit="true" v-if="modals.welcome.active" classs="d-none d-md-flex" cClass="" padding="p-0" mClass="height-unlimit" @cancel="closeWelcomePopup">
      <template #default>
        <PerfectScrollbar class="welcome-popup">
          <button class="btn btn-close" @click.stop="closeWelcomePopup">
            <i class="icon icon-cancel"></i>
          </button>
          <section class="row section bg-mono3 py-half pr-3">
            <div class="section-content text-light pb-1 pt-2">
              <h2>{{ $t("newToOld.welcome") }}</h2>
              <h1 class="d-inline-flex">{{ $t("newToOld.newV") }}</h1>
              <p class="mt-1">
                <b>{{ $t("newToOld.dear") }}</b>
              </p>
              <p>{{ $t("newToOld.introduceToday") }}</p>
              <p>{{ $t("newToOld.workingHard") }}</p>
            </div>
          </section>
          <section class="row section">
            <div class="section-content pt-3 pr-3 pb-2">
              <h3 style="color: #0729B0;">{{ $t("newToOld.news") }}</h3>
              <div class="features row mt-n1">
                <div class="col-6 mt-3" v-for="(feat, i) in newFeatures" :key="i + '_' + Date.now()">
                  <div class="feature">
                    <h4 class="feature-title">{{ feat.title }}</h4>
                    <p class="feature-desc mt-1">{{ feat.desc }}</p>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <div class="pos-a image-container">
            <img :src="publicPath + require('@/core/assets/Dashboardv3/welcome-new.png')" alt="" />
          </div>
        </PerfectScrollbar>
      </template>
    </Modal>
    <OnBoarding v-if="modals.onboarding.active" :type="modals.onboarding.type" @forceClose="forceCloseOnboarding" @continue="continueStartedGuide" @close="closeOnboardModal" />
    <StartedGuide @open_onboard="openOnbroading" />
    <PortalTarget name="modals" multiple></PortalTarget>
    <GDialogContainer />
    <Sidebar v-if="shopInfo" />
    <PortalTarget name="tooltips" multiple></PortalTarget>
    <template v-if="gSnackbar.message != '' && gSnackbar.type != ''">
      <GSnackBar :message="gSnackbar.message" :type="gSnackbar.type" />
    </template>

    <!-- <GetHelp /> -->
    <MaintainModal v-if="isMaintainMode" />
    <AbTestingBlockModal v-if="shopInfo" />

    <GLoading class="sync-with-editor" hasFrame :size="gLoadingSize" :noOverlay="false" v-if="gLoadingActive">
      <template #text>
        {{ gLoadingText }}
      </template>
    </GLoading>
  </main>
</template>

<script>
import { mapMutations, mapActions, mapState, mapGetters } from "vuex";
import { Sidebar, NotiCenter, FaqsModal, OnBoarding, StartedGuide, MaintainModal, NotiBar, LoadingFrame } from "@/core/components";
import { types } from "@/store";
import StoreSelect from "@/modules/Dashboard/components/StoreSelect";
import { ProcessButton } from "@/core/shared";
// import GetHelp from "@/core/components/gethelp/GetHelp.vue";
import { GpInputSearch } from "@/core/shared/GpForms";
import { FilterPage } from "@/modules/Shopify/components";
import GDialogContainer from "@/core/components/common/GDialogContainer.vue";
import NotificationPopup from "@/core/components/NewNotificationCenter/NotificationPopup.vue";
import AbTestingBlockModal from "@/core/components/AbTestingBlockModal.vue";

// import greetingNow from "@/plugins/greeting.js";
import Cookies from "@/utils/cookie.js";
import getLocale from "@/mixins/getLocale.js";
import { readI18n } from "@/i18n.js";
import obsLocalData from "@/utils/obsLocalData.js";
import newObsLocalData from "@/utils/newObsLocalData.js";
import errorHandle from "@/mixins/errorHandle";
import checkGlobalConfigs from "@/mixins/checkGlobalConfigs";
import { detectAnyAdblocker } from "@/plugins/antiAdblock/index.js";
import { transformPageNameToHandleType } from "@/store/newonboarding/actions";
import { actions } from "@/store/newonboarding/types.js";

import posthog from "posthog-js";
import initGemPagesV7 from "@/mixins/initGemPagesV7.js";

const INTERCOM_ERROR_KEY = "INTERCOM_ERROR";

export default {
  name: "Root",
  components: {
    NotiBar,
    OnBoarding,
    StartedGuide,
    Sidebar,
    NotiCenter,
    StoreSelect,
    ProcessButton,
    LoadingFrame,
    FaqsModal,
    // GetHelp,
    GpInputSearch,
    FilterPage,
    GDialogContainer,
    MaintainModal,
    NotificationPopup,
    AbTestingBlockModal
  },
  mixins: [getLocale, errorHandle(), checkGlobalConfigs(), initGemPagesV7],
  data() {
    return {
      headerVisible: true,
      headerTitle: "Hello, GemPages",
      headerDomain: "",
      headerSubtitle: "",
      headerDescription: "",
      headerEnableBreadcrum: false,
      breadcrums: [],

      modalAgencyLogin: false,
      queryShopName: "",
      formControl: {
        email: "",
        password: "",
        error: {
          email: null,
          password: null,
          other: null
        },
        showPassword: false
      },
      modalAgencyShopLogin: true,

      modals: {
        holiday: {
          active: false
        },
        welcome: {
          active: false
        },
        sharedLibrary: {
          active: false,
          accepted: false,
          data: null,
          error: null,
          status: false,
          viewFull: false,
          showShowMore: true
        },
        onboarding: {
          active: false,
          type: ""
        }
      },
      alertCount: null,
      shopsFilter: "",
      intercomInterval: -1,
      isMaintainMode: process.env.VUE_APP_MAINTAIN_MODE === "true" || false
    };
  },
  computed: {
    ...mapState({
      sidebarOpening: state => state.drawer.opening,
      import_status: state => state.template.status.import
    }),
    ...mapState("account", {
      permissions: state => state.permissions,
      shopInfo: state => state.shopInfo,
      accounStatus: state => state.status,
      instantShopId: state => state.instantShopId
    }),
    ...mapGetters("account", {
      accountExpired: "accountExpired",
      statusLoadingShopInfo: "statusLoadingShopInfo"
    }),
    ...mapGetters("common", {
      gSnackbar: "gSnackbar",
      gLoading: "gLoading"
    }),
    ...mapState("agency", {
      agencyLogged: state => state.logged,
      agencyFetched: state => state.fetched,
      shopList: state => state.shopList,
      agencyInfo: state => state.info,
      isOpenAgencySwitchModal: state => state.isOpenSwitchModal
    }),
    ...mapState("tutorial", {
      isFaqsModalActive: state => state.faqs.isModalActive
    }),
    ...mapGetters("notibar", {
      sticky: "sticky",
      notiAction: "noti_action",
      last_system_noti: "last_system_noti"
    }),
    ...mapGetters("dashboard", {
      loadingDashboard: "loading"
    }),
    ...mapState("page", {
      loadingFrame: "loadingFrame"
    }),
    noti() {
      if (this.last_system_noti && this.last_system_noti[0]) {
        return this.last_system_noti[0];
      }
      return undefined;
    },
    shopDomainURL() {
      return `https://${this.shopInfo.shopifyDomain}`;
    },
    notDashboard() {
      return this.$route.name == "Dashboard" ? false : true;
    },
    layoutIframe() {
      return this.$route.meta.layoutIframe ? true : false;
    },
    newFeatures() {
      return [
        {
          title: this.$t("newToOld.feat1.title"),
          desc: this.$t("newToOld.feat1.desc")
        },
        {
          title: this.$t("newToOld.feat2.title"),
          desc: this.$t("newToOld.feat2.desc")
        },
        {
          title: this.$t("newToOld.feat3.title"),
          desc: this.$t("newToOld.feat3.desc")
        },
        {
          title: this.$t("newToOld.feat4.title"),
          desc: this.$t("newToOld.feat4.desc")
        }
      ];
    },
    notiModalClass() {
      if (this.notiAction.noti.settings) {
        return "mw950" + (this.notiAction.noti.settings["extend-trial"] ? " extend-trial bg-white" : "");
      }
      return "mw950";
    },
    switchAgencyModalClass() {
      return "agencyModal";
    },
    gLoadingSize() {
      return this.gLoading.size;
    },
    gLoadingActive() {
      return this.gLoading.active;
    },
    gLoadingText() {
      return this.gLoading.text;
    },
    headerTitleText() {
      return readI18n(this, this.headerTitle);
    },
    headerSubtitleText() {
      return readI18n(this, this.headerSubtitle);
    },
    headerDescriptionText() {
      return readI18n(this, this.headerDescription);
    },
    notiContent() {
      return this.getLocaleText(this.notiAction.noti.content);
    },
    notiTitle() {
      return this.getLocaleText(this.notiAction.noti.title);
    },
    sortedShopList() {
      return this.shopList.list
        .filter(shop => {
          return shop.profile.domain.toLowerCase().includes(this.queryShopName.toLowerCase()) || shop.profile.name.toLowerCase().includes(this.queryShopName.toLowerCase());
        })
        .sort((shopA, shopB) => {
          switch (this.shopsFilter) {
            case "nameAsc":
              if (shopA.profile.name.toLowerCase() > shopB.profile.name.toLowerCase()) {
                return 1;
              } else {
                return -1;
              }
            case "nameDesc":
              if (shopA.profile.name.toLowerCase() < shopB.profile.name.toLowerCase()) {
                return 1;
              } else {
                return -1;
              }
            case "plan":
              if (shopA.plan > shopB.plan) {
                return 1;
              } else {
                return -1;
              }
            case "addedDate":
              if (shopA.agency_created > shopB.agency_created) {
                return 1;
              } else {
                return -1;
              }
          }
        });
    }
  },
  watch: {
    "$route.meta": {
      deep: true,
      handler(meta) {
        setTimeout(() => {
          this.setMeta(meta);
        }, 0);
      }
    },
    shopInfo() {
      if (this.$route.name == "Dashboard") {
        // this.setGreeetingText();
        this.setMeta();
      }
      this.setAlertModal();
    },
    statusLoadingShopInfo() {
      if (this.isMaintainMode) {
        this.$refs.gfLoadingFrame.hideLoading();
        return;
      }
      if (this.statusLoadingShopInfo) {
        this.$refs.gfLoadingFrame.showLoading();
      } else {
        this.$refs.gfLoadingFrame.hideLoading();
      }
    }
  },
  async created() {
    // this.checkHoliday();
    // this.checkSwitch();
    this.setBFCMBannerClosed(!!window.localStorage.getItem("bfcmBannerClosedBefore"));
    this.attachClickEventListener();
    this.checkShareLibrary();
    await this.fetchPaymentInfo();
    let code = this.modals.sharedLibrary && this.modals.sharedLibrary.data && this.modals.sharedLibrary.data.code;
    if (code != null && code != undefined) {
      this.whoAmI({
        sharedId: code,
        onSuccess: data => {
          if (data.data && data.data.import_status) {
            this.modals.sharedLibrary.accepted = true;
            this.modals.sharedLibrary.status = data.data.import_status;
            // this.clearSharedLibraryStorage();
          }
          this.initTracking();
        }
      });
    } else {
      this.whoAmI({
        getSurvey: true,
        getGA: true,
        onSuccess: () => {
          this.checkStatusOBS();
          // this.checkSubmitingOBS();
          this.initTracking();
        }
      });
    }
    // this.sytemSettingGetHelp();
    this.$body = this.$refs.mainBody;
    this.setMeta();
    let doit = async () => {
      await this.getAgency();
      if (this.agencyLogged) {
        await this.fetchShopList({ type: "shopList" });
      }
    };

    let interval = setInterval(() => {
      if (this.shopInfo) {
        clearInterval(interval);
        if (this.shopInfo.hasAgency) {
          doit();
        }

        // Get shop GemPages 7
        if (!this.shopInfo.shopType.isGemPagesV6 && !this.instantShopId) {
          this.connectGemPagesV7();
        }
      }
    }, 50);
  },
  mounted() {
    this.setMeta();
  },
  updated() {
    if (this.modals.sharedLibrary.data) {
      this.checkShowMoreLibrary();
    }
  },
  beforeDestroy() {
    window.removeEventListener(INTERCOM_ERROR_KEY, this.checkAdblock);
    clearInterval(this.intercomInterval);
  },
  methods: {
    ...mapActions("onboarding", {
      submitSurveyInfo: "obsSubmitSurveyinfo"
    }),
    ...mapActions("newonboarding", {
      updateSurveyOnboarding: actions.UPDATE_SURVEY_ONBOARDING
    }),
    ...mapMutations("page", { ...types.page.mutations }),
    ...mapActions("page", { ...types.page.actions }),
    ...mapActions("tutorial", {
      openFaqsModal: "openFaqsModal",
      closeFaqModal: "closeFaqsModal",
      openStartedGuide: "openStartedGuide",
      getSection: "sectionGet",
      closeStarted: "closeStartedGuide"
    }),
    ...mapActions("agency", {
      fetchShopList: "fetchShopList",
      getAgency: "getAgency",
      closeSwitchAgencyModal: "closeSwitchAgencyModal"
    }),
    ...mapActions("account", {
      whoAmI: "accountWhoAmI",
      agencyLogin: "accountAgencyLogin"
      // sytemSettingGetHelp: "sytemSettingGetHelp",
    }),
    ...mapActions("template", {
      importLibrary: "templateAcceptImport"
    }),
    ...mapActions("notibar", {
      toogleStickyModal: "toogleSticky",
      toogleStickyModalFirstTime: "toogleStickyFirstTime",
      closeStickyModal: "closeModalNoti",
      showModalNoti: "showModalNoti",
      trackAction: "trackAction"
    }),
    ...mapActions("dashboard", {
      getAllDashboardData: "getAllDashboardData",
      fetchPaymentInfo: "fetchPaymentInfo"
    }),
    ...mapMutations("dashboard", {
      setBFCMBannerClosed: "setBFCMBannerClosed"
    }),
    continueStartedGuide() {
      this.modals.onboarding.active = false;
      this.openStartedGuide();
    },
    forceCloseOnboarding() {
      this.modals.onboarding.active = false;
      this.closeStarted();
    },
    isEmpty(value) {
      let _val = (value || "").trim();
      return !_val || !_val.length;
    },
    toggleShowPassword() {
      this.formControl.showPassword = !this.formControl.showPassword;
    },
    checkLogin() {
      let { email, password } = this.formControl;
      let _error = this.formControl.error;
      _error.email = null;
      _error.password = null;
      _error.other = null;

      let emailEmpty = this.isEmpty(email);
      let passEmpty = this.isEmpty(password);
      if (emailEmpty) {
        _error.email = this.$t("generals.fieldRequired");
      }
      if (passEmpty) {
        _error.password = this.$t("generals.fieldRequired");
      }
      if (emailEmpty || passEmpty) return false;
      let credential = { email, password };
      this.agencyLogin({
        credential,
        onSuccess: () => {
          this.getAgency();
          this.fetchShopList({ type: "shopList", reFetch: true });
          setTimeout(() => {
            this.modalAgencyLogin = false;
          }, 1500);
        },
        onError: () => {
          _error.other = this.$t("agency.wrongUoP");
        }
      });

      return false;
    },
    setMeta(meta = this.$route.meta) {
      if (meta.headerVisible !== undefined) {
        this.headerVisible = meta.headerVisible;
      }

      if (meta.headerTitle !== undefined) {
        this.headerTitle = meta.headerTitle;
      }
      if (meta.headerDescription !== undefined) {
        this.headerDescription = meta.headerDescription;
      } else {
        this.headerDescription = null;
      }

      if (meta.headerDomain !== undefined) {
        this.headerDomain = meta.headerDomain;
      }

      if (meta.headerSubtitle !== undefined) {
        this.headerSubtitle = meta.headerSubtitle;
      } else {
        this.headerSubtitle = null;
      }

      if (!meta.breadcrums) {
        this.breadcrums = [];
      } else {
        this.breadcrums = meta.breadcrums;
      }

      if (meta && meta.scrollTop != undefined && this.$refs.mainBody) {
        this.$refs.mainBody.scrollTop = 0;
      }
    },
    // setGreeetingText() {
    //   if (this.shopInfo) {
    //     let _greet = greetingNow();
    //     let greeting = this.$t(_greet);
    //     this.$route.meta.headerTitle = `${greeting}, ${this.shopInfo.firstName} ${this.shopInfo.lastName}`;

    //     if (this.shopInfo.remainingDays <= 5 && this.shopInfo.remainingDays >= 1) {
    //       this.$route.meta.headerTitle = `${this.$t("dashboard.thankForUsing")}, ${this.shopInfo.firstName} ${this.shopInfo.lastName}`;
    //     }

    //     this.$route.meta.headerDomain = this.shopInfo.shopifyDomain;
    //   }
    // },
    setAlertModal() {
      //
      if (this.shopInfo) {
        this.alertCount = JSON.parse(window.localStorage.getItem("alertCount"));
        if (this.alertCount == undefined) {
          this.alertCount = new Object();
        }
        if (this.shopInfo.noti == undefined) {
          // this.shopInfo.noti = new Object();
          return;
        }
        if (this.alertCount[this.shopInfo.noti.id] == undefined) {
          this.alertCount[this.shopInfo.noti.id] = 0;
        } else {
          if (this.alertCount < 3) {
            this.alertCount[this.shopInfo.noti.id] += 1;
          }
        }
        window.localStorage.setItem("alertCount", JSON.stringify(this.alertCount));

        // alert(this.alertCount[this.noti.id]);
        if (this.alertCount[this.shopInfo.noti.id] > 3) {
          this.toogleStickyModal();
        }
      }
    },
    openModalLogin() {
      this.modalAgencyLogin = true;
    },
    closeModalLogin() {
      this.modalAgencyLogin = false;
    },
    openModalShopLogin() {
      this.modalAgencyShopLogin = true;
    },
    closeModalShopLogin() {
      this.modalAgencyShopLogin = false;
    },
    closeSwitchAgency() {
      this.closeSwitchAgencyModal();
    },
    checkShareLibrary() {
      let sharedLibrary = window.localStorage.sharedLibrary;
      if (sharedLibrary) {
        this.modals.sharedLibrary.active = true;
        try {
          this.modals.sharedLibrary.data = JSON.parse(sharedLibrary);
        } catch (error) {
          error;
        }
      }
    },
    acceptLibrary() {
      const {
        data: { code }
      } = this.modals.sharedLibrary;

      this.modals.sharedLibrary.error = null;
      this.importLibrary({ code })
        .then(() => {
          this.modals.sharedLibrary.accepted = true;
          // this.clearSharedLibraryStorage();
        })
        .catch(err => {
          this.modals.sharedLibrary.error = this.getErrorMessage(err);
        });
    },
    discardLibrary() {
      this.modals.sharedLibrary.active = false;
      this.clearSharedLibraryStorage();
    },
    closeSharedLibrary() {
      this.modals.sharedLibrary.active = false;
      this.clearSharedLibraryStorage();
    },
    clearSharedLibraryStorage() {
      window.localStorage.removeItem("sharedLibrary");
    },
    checkShowMoreLibrary() {
      let $textDesc = this.$refs && this.$refs.textDescriptionLibrary;
      if ($textDesc) {
        if (this.modals.sharedLibrary.checked) return;
        this.modals.sharedLibrary.checked = true;
        let $parent = $textDesc.parentElement;
        if ($textDesc.offsetHeight <= $parent.offsetHeight) {
          this.modals.sharedLibrary.showShowMore = false;
        }
      }
    },
    // checkHoliday() {
    //   const dismissTetBanner = Cookies.get("gfTet2020");
    //   if (!dismissTetBanner) {
    //     this.modals.holiday.active = true;
    //   }
    // },
    // checkSwitch() {
    //   const switchFirstTime = Cookies.get("gfSwitchFirstTime");
    //   if (!switchFirstTime) {
    //     this.modals.welcome.active = true;
    //   }
    // },
    // checkOnboarding() {
    //   const isFirstLoad = Cookies.get("__gfFirstLoad");
    //   if (!isFirstLoad) {
    //     this.isFirstLoad = true;
    //     Cookies.set("__gfFirstLoad", )
    //   }
    // },
    checkStatusOBS() {
      let surveys = [];
      surveys = this.shopInfo ? this.shopInfo.surveys : [];
      const shopifyDomain = this.shopInfo && this.shopInfo.shopifyDomain;
      const surveyObs = surveys.filter(sv => sv.handle == "onboarding") || [];
      const newObs = surveys.filter(sv => sv.handle == "onboarding-v2") || [];
      const hasNoOldObs = surveyObs && surveyObs.length == 0;
      const hasNoNewObs = newObs && newObs.length == 0;

      const newObReleaseDate = "2022-08-17T03:19:38.507Z";
      const shopCreatedAt = this.shopInfo.createdAt.toString();
      const isNewShop = shopCreatedAt > newObReleaseDate;
      if (newObsLocalData.check(shopifyDomain)) {
        if (!hasNoOldObs && !hasNoNewObs) return;
        const lastSurvey = newObsLocalData.get(shopifyDomain) || {};
        const lastSurveyData = lastSurvey.store || {};
        const isDoneSurvey = lastSurveyData["doneSurvey"];
        if (isDoneSurvey) {
          // if Survey On Local Storage True And Survey on Api False => Update Survey Again
          this.retryUpdateSurveyOnboarding(lastSurveyData);
          return;
        }
        if (isNewShop) {
          if (this.isMaintainMode) {
            return;
          }
          // this.$router.replace({ name: "Welcome" });
        }
        return;
      }
      if (!newObsLocalData.check(shopifyDomain) && !obsLocalData.check(shopifyDomain)) {
        if (hasNoOldObs && hasNoNewObs && isNewShop) {
          if (this.isMaintainMode) {
            return;
          }
          // this.$router.replace({ name: "Welcome" });
        }
      }
    },
    retryUpdateSurveyOnboarding(lastSurveyData) {
      const params = {
        pageType: transformPageNameToHandleType(lastSurveyData["objective"]),
        industry: lastSurveyData["industries"]
      };
      this.updateSurveyOnboarding(params).then(res => {
        if (res.data && res.data.message == "success") {
          newObsLocalData.removeAll();
        }
      });
      return false;
    },
    checkSubmitingOBS() {
      const shopifyDomain = this.shopInfo.shopifyDomain;
      setTimeout(() => {
        if (obsLocalData.check(shopifyDomain)) {
          const lastSurvey = obsLocalData.get(shopifyDomain) || {};
          const lastSurveyData = lastSurvey.store || {};
          const surveys = this.shopInfo && this.shopInfo.surveys ? this.shopInfo.surveys : [];
          const surveyObs = surveys.filter(sv => sv.name == "onboarding");
          if (lastSurveyData["almostDoneFail"]) {
            const dataBody = {
              data: lastSurveyData.dataSubmit || {},
              status: "step4",
              shopifyDomain: shopifyDomain
            };
            setTimeout(() => {
              if (surveyObs && surveyObs.length > 0 && surveyObs[0].name == "onboarding") {
                this.submitSurveyInfo(dataBody);
              }
            }, 2000);
          }
          if (lastSurveyData["subscribedFail"]) {
            const dataBody = {
              data: lastSurveyData.dataSubcribeSubmit || {},
              status: "final",
              shopifyDomain: shopifyDomain
            };
            setTimeout(() => {
              if (surveyObs && surveyObs.length > 0 && surveyObs[0].name == "onboarding") {
                this.submitSurveyInfo(dataBody);
              }
            }, 2000);
          }
          if (lastSurveyData["skippedFail"]) {
            const dataBody = {
              data: { onboarding_skipped: true },
              status: "skip",
              shopifyDomain: shopifyDomain
            };
            setTimeout(() => {
              if (surveyObs && surveyObs.length > 0 && surveyObs[0].name == "onboarding") {
                this.submitSurveyInfo(dataBody);
              }
            }, 2000);
          }
        }
      }, 1000);
    },
    closeWelcomePopup() {
      this.modals.welcome.active = false;
      Cookies.set("gfSwitchFirstTime", "seen", 3 * 365 * 24 * 3600);
      if (this.noti != undefined) {
        if (this.noti && this.noti.state <= 1 && this.noti.action_count <= 1 && this.noti.action == "open_modal" && this.noti.is_important && new Date(this.noti.from_date) <= Date.now() && new Date(this.noti.to_date) >= Date.now()) {
          this.showModalNoti(this.noti);
          this.trackAction(this.noti);
        }
        return;
      }
    },
    dismissHoliday() {
      this.modals.holiday.active = false;
      Cookies.set("gfTet2020", "dismiss", 360 * 24 * 60 * 60);
    },
    closeNoti() {
      this.closeStickyModal();
    },
    closeFaqs() {
      this.closeFaqModal();
    },
    gotoHelpCenter() {
      this.$chatbox.show();
    },
    gotoUpgrade() {
      this.$router.replace({ name: "Pricing" });
    },
    openOnbroading(e) {
      this.modals.onboarding.active = true;
      this.modals.onboarding.type = e;
    },
    closeOnboardModal() {
      this.modals.onboarding.active = false;
      this.openStartedGuide();
    },
    searchShop(e) {
      this.queryShop = e;
    },
    onClickFilter(filter) {
      this.shopsFilter = filter;
    },
    initTracking() {
      if (this.shopInfo) {
        if (process.env.VUE_APP_ENV === "staging") {
          posthog.init("phc_bisQHZH8BZy6zmgKQDbbB8ZMsdrD8JKy7Ch7qRGifUD", {
            api_host: "https://app.posthog.com",
            autocapture: false,
            loaded: function(posthog) {
              posthog.identify(this.shopInfo.shopifyDomain, {});
            }
          });
        }
      }
    },
    attachClickEventListener() {
      window.addEventListener("click", () => {
        window.parent.postMessage("gpClickWindow", "*");
      });
    },
    checkAdblock() {
      const COOKIE_KEY = "gfAdblockDetected";
      if (Cookies.get(COOKIE_KEY) == "seen") {
        // eslint-disable-next-line no-console
        console.warn("Adblock detected");
        return;
      }
      try {
        detectAnyAdblocker().then(detected => {
          if (detected) {
            // an adblocker is detected
            this.gDialogCommit({
              type: "error",
              message: "error.adblockerDetected",
              containerPadding: "p-4 px-6"
            });
            Cookies.set(COOKIE_KEY, "seen", 24 * 3600);
          }
        });
      } catch (error) {
        // console.error(error)
        // silence is golden
      }
    }
  }
};
</script>

<style lang="scss" scoped>
// @import "@/core/themes/base.scss";
.bg {
  background-color: $bg;
}

.sticky-head {
  position: sticky;
  top: 0;
  z-index: 2;
  background-color: $bg;
  padding-top: 40px;
}

.gp-wrapper {
  &.bg {
    .gp-main-body {
      padding: 0 88px 60px 88px;
    }
  }
}

main {
  .noPaddingTop {
    padding-top: 0px !important;
  }

  .layout-iframe {
    padding: 0px !important;
    margin: 0px !important;
    width: 100% !important;
    max-width: 100% !important;
    overflow: hidden !important;
    height: 100vh !important;
    max-height: calc(100vh - 60px) !important;

    .gp-main-body-wrapper {
      width: 100% !important;
      height: 100% !important;
      padding: 0 !important;
    }
  }
}

.faqs-exit {
  margin-bottom: 168px;

  // margin-bottom: 40px;
  @media only screen and (min-width: 1024px) {
    margin-bottom: 80px;
  }

  @media only screen and (min-width: 1280px) {
    margin-bottom: 100px;
  }

  @media only screen and (min-width: 1440px) {
    margin-bottom: 168px;
  }
}

::v-deep .extend-trial {
  .d-flex {
    > svg {
      flex-shrink: 0;
    }
  }

  position: relative;

  &-close {
    position: absolute;
    top: 36px;
    right: 36px;
  }

  &-h1 {
    background: linear-gradient(0deg, #ffd028 -11.54%, #fbeaae 111.24%);
    font-size: 87px;
    line-height: 125px;
    width: 100px;
    text-align: center;

    .depth {
      // color: transparent;
      // text-shadow: 2px 2px 3px rgba(255, 255, 255, 0.2);
      // -webkit-background-clip: text;
      // -moz-background-clip: text;
      // background-clip: text;
      &-important {
        color: rgba(236, 54, 54, 0.8);
        text-shadow: 1px 2px 4px #ffbdbd, 0 0 0 #000, 0px 1px 4px #ffbdbd;
      }

      &-normal {
        color: rgba(9, 63, 255, 0.8);
        text-shadow: 1px 1px 6px #c3d0ff, 0 0 0 #000, 0px 1px 1px #c3d0ff;
      }
    }
  }

  &-h3 {
    font-style: normal;
    font-weight: bold;
    font-size: 48px;
    line-height: 130%;
    /* or 62px */

    letter-spacing: -0.005em;
    text-transform: uppercase;
  }

  &-h4 {
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 130%;
    letter-spacing: -0.005em;
    text-transform: capitalize;
  }

  &-img {
    max-width: 100%;

    > img {
      width: 120%;
      transform: translateX(-8%);
    }
  }

  &-14 {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 150%;
  }

  &-16 {
    font-style: normal;
    font-size: 16px;
    line-height: 130%;
  }

  &-32 {
    font-style: normal;
    font-weight: bold;
    font-size: 32px;
    line-height: 130%;
    letter-spacing: -0.005em;
  }

  &-60 {
    font-style: normal;
    font-weight: bold;
    font-size: 60px;
    line-height: 44px;
    letter-spacing: -0.005em;
    margin-bottom: 16px;
  }

  .extend-trial-content {
    position: relative;
    z-index: -1;
  }

  .btn-group {
    // position: absolute;
    // bottom: 48px;
    // right: 80px;
    margin-top: -64px;
    margin-right: 16px;
    z-index: 1;

    .btn {
      margin-left: 24px;
      width: 200px;
      height: 40px;

      &-invert {
        color: $textLightModeHigh;
        background: $light3;
        border: $light3;
      }
    }
  }
}

.noti-exit {
  position: absolute;
  top: 8px;
  right: 8px;
  border-radius: $radius;
  transition: all ease 0.3s;

  &:hover {
    background: $textDarkModeHigh;
  }
}

.global-loading {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 99999;

  ::v-deep {
    .gfLoader {
      background-color: rgba(#000, 0.7);

      &-frame-medium {
        $size: 120px;
        width: $size;
        height: $size;
      }
    }
  }
}

.login-btn {
  color: $cSecondary4;
  font-size: 14px;
  line-height: 21px;
  text-decoration-line: underline;
}

.login-btn:hover {
  cursor: pointer;
}

.shop-info {
  // cursor: pointer;
  .shop-logo img {
    height: 40px;
  }

  .shop-name {
    line-height: 30px;
    margin-bottom: 8px;
  }

  .domain {
    display: inline-block;
    @include trans-all;

    &:hover {
      color: $cPrimary;
    }
  }
}

::v-deep .gp_modal-container.maxw-80p {
  width: 80%;
  max-width: 1000px;
  min-width: 320px;
}

::v-deep .gp_modal-container.maxw-50p {
  width: 70%;
  max-width: 750px;
  min-width: 320px;
}

.shareable-template-modal {
  .maxh-adaptive {
    max-height: calc(100vh - 64px - 112px - 24px - 112px);
    overflow: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .content-img {
    width: 100%;
    align-self: center;

    &.maxw-360 {
      max-width: 360px;
    }

    &.maxw-500 {
      max-width: 500px;
    }
  }

  > .description {
    line-height: 180%;
  }

  .btn-secondary {
    background-color: #e5e6e8;
    color: $textLightModeHigh;

    &:hover {
      background-color: #e0e0e0;
    }
  }
}

.long-desc {
  position: relative;

  .desc-faded {
    background: linear-gradient(to bottom, rgba(100, 100, 100, 0) 0%, #ffffff 75%);
    height: 100px;
    position: absolute;
    width: 100%;
    bottom: 0;
  }

  .description {
    word-break: break-word;
  }

  &.hide-text {
    min-height: 150px;
    max-height: 50vh;
    overflow: hidden;
  }

  &.full-desc {
    max-height: unset;
    overflow: unset;
    min-height: unset !important;

    .desc-faded {
      display: none;
    }
  }

  + .show-more-btn {
    // display: none;
    padding: 4px;
    cursor: pointer;
    transition: color 0.2s ease;

    &:hover {
      color: $cPrimary;
    }
  }
}

.agency-login-form {
  border-radius: 5px;
  background: #fff;
  box-shadow: 0px 7px 64px rgba(0, 24, 46, 0.15);
}

// new
::v-deep.tet2020 {
  background-color: #f8fbff;
  position: relative;

  &-heading {
    font-weight: 600;
    font-size: 36px;
    line-height: 120%;
    letter-spacing: -0.005em;
  }

  &-divider {
    background: #fff;
    height: 4px;
    background-blend-mode: screen;
    box-shadow: inset 1px 1px 1px #d0dffa;
    border-radius: 9px;
  }

  &-feature-image {
    @include flex-center;

    img {
      width: 80%;
    }
  }

  &-content {
    max-height: calc(100vh - 56px);
    // overflow: overlay;
    background: #fefefe;
    box-shadow: 8px 8px 32px rgba(255, 226, 154, 0.2);
    border-radius: 5px 0 0 5px;

    &-paragraph {
      color: $cSecondary4;
      font-weight: normal;
      font-size: 14px;
      line-height: 145%;

      &:not(.text-secondary4) {
        strong,
        a {
          color: $cRed;
          font-weight: 600;
        }
      }
    }
  }

  &-firework {
    position: absolute;
    bottom: 3px;
    right: 7px;
  }
}

.welcome-popup {
  position: relative;
  width: 950px;
  max-height: 95vh;
  height: 670px;
  // overflow: overlay;
  padding: 0 12px;
  background: linear-gradient(319.13deg, #f5f5f5 54.51%, #ffffff 89.02%);

  // height: 700
  .section {
    // width: 100%;
    min-height: 100px;

    &-content {
      margin-left: auto;
      max-width: 60%;

      h2 {
        font-weight: 600;
        font-size: 34px;
        line-height: 125%;
        letter-spacing: -0.005em;
      }

      h1 {
        font-style: normal;
        font-weight: 600;
        font-size: 63px;
        line-height: 125%;
        letter-spacing: -0.005em;
        border-bottom: 3px solid $accent-yellow;
        margin-top: -8px;
      }

      p {
        font-size: 16px;
        line-height: 24px;
        letter-spacing: -0.01em;
      }

      h3 {
        font-weight: bold;
        font-size: 24px;
        line-height: 29px;
      }
    }

    .feature {
      padding: 18px 12px;
      border: 1px solid $dark4;
      height: 100%;

      &-title {
        font-weight: 600;
        font-size: 16px;
        line-height: 19px;
      }

      &-desc {
        font-weight: normal;
        font-size: 14px;
        line-height: 21px;
      }
    }
  }

  .image-container {
    left: 0;
    bottom: 0px;
    height: 100%;
    overflow: hidden;

    img {
      height: 100%;
      transform: translateY(7px);
    }
  }

  .btn-close {
    position: absolute;
    top: 24px;
    right: 24px;
    padding: 12.5px;
    $size: 50px;
    width: $size;
    height: $size;
    font-size: 25px;
    line-height: 1;
    background: transparent;
    color: $light1;

    &:hover {
      background: $light1;
      color: #faa04e;
    }
  }
}

@media only screen and (max-width: 1023px) {
  .shareable-template-modal {
    .maxh-adaptive {
      max-height: calc(100vh - 64px - 112px - 24px - 120px);
    }
  }
}

@media only screen and (max-width: 767px) {
  html {
    overflow: hidden;

    main {
      display: flex;
      flex-direction: column;
    }

    .gp-wrapper {
      &.bg {
        .gp-main-body {
          padding: 0 16px 56px 16px;
        }
      }

      .bb1sg {
        display: none;
      }

      .gp-main-body-wrapper {
        // margin-top: 60px;
        padding-bottom: 16px;
        padding-left: 8px;
        padding-right: 8px;

        header {
          .row {
            justify-content: center;
          }

          .shop-info {
            height: 100%;
            width: 100%;
            text-align: center;

            h2 {
              font-weight: 600;
              font-size: 28px;
              line-height: 42px;
              // margin-bottom: 40px;
              // padding: 0 24px;
              // color: #ffffff;
            }

            p {
              text-align: left;
            }
          }
        }
      }
    }

    #gp-intercom {
      bottom: 70px !important;
    }
  }

  .shareable-template-modal {
    .maxh-adaptive {
      max-height: calc(100vh - 64px - 112px - 24px - 72px);
    }
  }
}

@media only screen and (max-width: 575px) {
  ::v-deep .gp_modal-container.maxw-80p {
    width: 100%;
  }

  .shareable-template-modal {
    .maxh-adaptive {
      max-height: calc(100vh - 184px);
    }

    .content-img.maxw-360 {
      max-width: 280px;
    }
  }

  .long-desc.hide-text {
    min-height: 100px;
  }
}

::v-deep .faqs-modal {
  .faqs-close {
    width: 40px;
    height: 40px;
    top: 88px;
    right: 88px;

    @media screen and (max-width: 767px) {
      top: 42px;
      right: 42px;
    }
  }
}

::v-deep .started-guide-container {
  margin-top: 0px !important;
  max-width: 888px;

  @media screen and (max-width: 767px) {
  }
}

@media (min-width: 1280px) {
  ::v-deep .close-class {
    position: absolute;
    top: 100px;
    right: 100px;
    padding: 12px;
  }
}

@media (max-height: 647px) {
  .welcome-popup {
    .image-container {
      height: auto;
      width: 50%;
      bottom: auto;
      transform: translateY(-100%);
    }
  }
}

.sync-with-editor {
  ::v-deep .gfLoader-frame-large {
    width: 120px;
    height: 120px;
    transform: translateY(-22px);
  }
}
</style>
